import React from 'react';
import PropTypes from 'prop-types';
//import classNames from 'classnames';
import {Button, Icon, Message} from 'epic-diesel-common';
import {getMessage} from '../../common/Message';
import {buttonTypes, sizes, priority, svgs} from 'epic-diesel-common/src/constants';
import CheckBox from 'epic-diesel-form/src/components/form/CheckBox';
import Select from 'epic-diesel-form/src/components/form/Select';
import Input from 'epic-diesel-form/src/components/form/Input';
import styles from './SocialAccountsSection.pcss';
import signupStyles from '../../../pages/signup/SignUp.pcss';
import getInfluencersFlowSchema from '../../../data/InfluencersFlowSchema';
import parse from 'url-parse';

const PLATFORM_MAPPING = {
    YOUTUBE_CHANNEL: 'epic.affiliate.signup.social.channels.dropdown.youtube',
    TWITCH_CHANNEL: 'epic.affiliate.signup.social.channels.dropdown.twitch',
    FACEBOOK: 'epic.affiliate.signup.social.channels.dropdown.facebook',
    VK: 'epic.affiliate.signup.social.channels.dropdown.vk',
    MIXER: 'epic.affiliate.signup.social.channels.dropdown.mixer',
    TWITTER: 'epic.affiliate.signup.social.channels.dropdown.twitter',
    //PODCAST_CHANNEL: 'epic.affiliate.signup.social.channels.dropdown.podcast',
    INSTAGRAM: 'epic.affiliate.signup.social.channels.dropdown.instagram',
    TIKTOK: 'epic.affiliate.signup.social.channels.dropdown.tiktok'
    //WEBSITE_CHANNEL: 'epic.affiliate.signup.social.channels.dropdown.website'
};

export default class SocialAccountsSection extends React.Component {
    static propTypes = {
        messages: PropTypes.object,
        channelValidated: PropTypes.bool,
        //socialValidated: PropTypes.bool,
        sectionData: PropTypes.object,
        onAddChannel: PropTypes.func,
        onRemoveChannel: PropTypes.func,
        guardian: PropTypes.bool,
        onPhoneNumberChange: PropTypes.func,
        socialAcknowledgment: PropTypes.bool,
        updateSocialAcknowledgment: PropTypes.func
        //accountManagementUrl: PropTypes.string,
        //getSocialLinks: PropTypes.func
    };
    static defaultProps = {
        sectionData: {}
        //accountManagementUrl: ''
    };

    constructor(props) {
        super(props);
        this.state = {
            platformDropdownOptions: [],
            platform: 'YOUTUBE_CHANNEL',
            url: '',
            invalidChannel: false
        };

        const {messages} = props;

        if (messages) {
            this.state.platformDropdownOptions = [];

            for (const val in PLATFORM_MAPPING) {
                if (PLATFORM_MAPPING.hasOwnProperty(val)) {
                    this.state.platformDropdownOptions.push({
                        label: getMessage(messages, PLATFORM_MAPPING[val]),
                        value: val
                    });
                }
            }
        }
    }

    onPlatformChange = (name, value) => {
        this.setState({
            platform: value
        });
    };

    onURLChange = event => {
        const {value} = event.target;
        this.setState({
            url: value
        });
    };

    onAddChannel = () => {
        const url = parse(this.state.url.trim(), {});
        const newState = {};

        if (!url.hostname) {
            newState.invalidChannel = true;
        } else {
            newState.url = '';
            newState.invalidChannel = false;

            const newHostname = url.hostname.toLowerCase();

            const newUrl = `https://${
                newHostname.indexOf('www.') === 0 ? newHostname.substring(4) : url.hostname
            }${url.pathname}`;

            this.props.onAddChannel({platform: this.state.platform, url: newUrl});
        }

        this.setState(newState);
    };

    onRemove = index => {
        this.props.onRemoveChannel(index);
    };

    onPhoneTextChange = event => {
        const {name, value} = event.target;
        const regex = /([^\d-\\(\\)])+/i;
        this.props.onPhoneNumberChange(name, value.replace(regex, ''));
    };

    render() {
        // const socialNetworkIcons = {
        //     facebook: glyphStyles.facebook,
        //     google: glyphStyles.google,
        //     twitch: glyphStyles.twitch,
        //     vk: glyphStyles.vk
        // };

        const {
            sectionData,
            messages,
            guardian
            // accountManagementUrl,
            // getSocialLinks
        } = this.props;

        const signUpInfoSchema = getInfluencersFlowSchema(getMessage, messages).signupInfo;

        const phoneNumberText = getMessage(messages, 'epic.affiliate.signup.social.phone_number');
        const channelUrlText = getMessage(
            messages,
            'epic.affiliate.signup.social.channels.dropdown.url'
        );
        //const socialLinkUrl = `${accountManagementUrl}/connected`;
        //const socialLinks = sectionData.socialLinks || [];

        // const socialItems = socialLinks.map((item, key) => {
        //     const noLink = item.externalDisplayName === null;

        //     const cls = classNames(
        //         styles.link,
        //         {
        //             [styles.noLink]: noLink
        //         }
        //     );

        //     return (
        //         <div
        //             className={cls}
        //             key={item.externalAuthIdType}>
        //             <Icon icon={socialNetworkIcons[item.externalAuthIdType]} size={sizes.MEDIUM} />
        //             {noLink ?
        //                 (
        //                     <a
        //                         href={socialLinkUrl}
        //                         target="_blank"
        //                         rel="noopener noreferrer">
        //                         <Message className={styles.linkId} code="epic.affiliate.signup.social.channels.connect" />
        //                     </a>
        //                 ) :
        //                 (<span className={styles.linkId}>{item.externalDisplayName}</span>)
        //             }
        //         </div>
        //     );
        // });

        return (
            <div className={signupStyles.header}>
                {/* <h2><Message code="epic.affiliate.signup.social.header" /></h2>
                <p><Message code="epic.affiliate.signup.social.text" /></p>

                <Button
                    priority={priority.TERTIARY}
                    type={buttonTypes.BUTTON}
                    onClick={getSocialLinks}
                    className={styles.refresh}>
                    <Message code="epic.affiliate.common.refresh" />
                </Button>

                <div className={styles.socialItem}>
                    {socialItems}
                    {!this.props.socialValidated && <span className={styles.errorMessage}> <Message code="epic.affiliate.social.accounts.required" /></span>}
                </div> */}

                <h2>
                    <Message
                        code={
                            guardian
                                ? 'epic.affiliate.signup.guardian.social.channels.header'
                                : 'epic.affiliate.signup.social.channels.header'
                        }
                    />
                    {' *'}
                </h2>
                <p>
                    <Message
                        code={
                            guardian
                                ? 'epic.affiliate.signup.guardian.social.text'
                                : 'epic.affiliate.signup.social.text'
                        }
                    />
                </p>
                <p>
                    <Message code="epic.affiliate.signup.social.text_code" />
                </p>

                <div className={styles.channeWrap}>
                    {sectionData.channels.map((item, key) => (
                        <div className={styles.channel} key={`${item.platform}-${item.url}`}>
                            <div className={styles.platformName}>
                                <Message code={PLATFORM_MAPPING[item.platform]} />
                            </div>
                            <div className={styles.channelUrl}>{item.url}</div>
                            <div className={styles.removeChannel}>
                                <Button
                                    priority={priority.TERTIARY}
                                    type={buttonTypes.BUTTON}
                                    onClick={() => this.onRemove(key)}>
                                    <Icon icon={svgs.CLOSE} size={sizes.XSMALL} />
                                </Button>
                            </div>
                        </div>
                    ))}
                </div>
                <div className={styles.addChannel}>
                    <div>
                        <Select
                            name="platform"
                            value={this.state.platform}
                            onChange={this.onPlatformChange}
                            options={this.state.platformDropdownOptions}
                        />
                    </div>
                    <div>
                        <Input
                            name="url"
                            value={this.state.url}
                            onChange={this.onURLChange}
                            placeholder={channelUrlText}
                            validations={signUpInfoSchema.url.validations}
                            validationErrors={signUpInfoSchema.url.validationMessages}
                            required={false}
                        />
                    </div>
                    <div>
                        <Button
                            priority={priority.TERTIARY}
                            type={buttonTypes.BUTTON}
                            onClick={this.onAddChannel}>
                            <Message code="epic.affiliate.common.add" />
                        </Button>
                    </div>
                </div>
                {this.state.invalidChannel && (
                    <span className={styles.errorMessage}>
                        {' '}
                        <Message code="epic.affiliate.signup.social.channels.dropdown.invalid_url" />
                    </span>
                )}
                {!this.state.invalidChannel && !this.props.channelValidated && (
                    <span className={styles.errorMessage}>
                        {' '}
                        <Message code="epic.affiliate.channel.required" />
                    </span>
                )}

                <div className={styles.phoneNumber}>
                    <Input
                        name="phoneNumber"
                        type="tel"
                        value={sectionData.phoneNumber}
                        onChange={this.onPhoneTextChange}
                        placeholder={phoneNumberText}
                        validations={signUpInfoSchema.phone.validations}
                        validationErrors={signUpInfoSchema.phone.validationMessages}
                        required={true}
                    />
                </div>
                <div className={styles.authentication}>
                    <CheckBox
                        name="socialAcknowledgment"
                        validations="checked"
                        validationError={getMessage(messages, 'ui.form.agreement.required')}
                        value={this.props.socialAcknowledgment}
                        onChange={this.props.updateSocialAcknowledgment}>
                        <Message code="epic.affiliate.signup.social.acknowledge" />
                    </CheckBox>
                </div>
            </div>
        );
    }
}
